import _ from 'lodash'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { Collapse } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

import { query } from '../atoms/BreakPoint'

import PartyComposition from './PartyComposition'

import config from '../../configs/config'

class Summary extends PureComponent {
  render () {
    const collapsed = !this.props.isSummaryElementExpanded && query.isXs()
    const summaryTitleNonCollapsible = classNames('m-0', {
      'hidden-xs': this.props.isSummaryTitleClickable
    })
    const summaryTitleCollapsible = classNames('hidden-sm hidden-md hidden-lg', {
      'hidden-xs': !this.props.isSummaryTitleClickable,
      'collapsed': collapsed
    })
    const context = _.get(config, 'packageRatesReply.meta.context', {})
    const { adults, children } = context.roomRates || {}
    const selectedItems = context.selectedItems ? context.selectedItems[Object.keys(context.selectedItems)[0]] : null
    const hasTicketDescriptions = _.get(config, 'brandConfig.secure.hasFeatures.hasTicketDescriptions', false)
    if (_.get(config, 'brandConfig.secure.hasFeatures.availability.hasSimplifiedSummary', false)) {
      return (
        <React.Fragment>
          <div className='summary-panel container block-sm'>
            <div className='row'>
              <div className='col-lg-3 col-sm-2'>
                <a
                  className={summaryTitleCollapsible}
                  onClick={this.props.handleSummaryCollapseToggle}
                  onKeyDown={(e) => e.key === 'Enter' && this.props.handleSummaryCollapseToggle}>
                  <h3 className='h3 mt-0'>
                    <FormattedMessage id='common.summary' /> <span className='i-plus pull-right collapse-icon'>+</span>
                  </h3>
                </a>
              </div>

              <Collapse in={!collapsed}>
                <div className='summary-content collapse-non-sm collapse-non-md collapse-non-lg'>
                  <div className='row'>
                    <div className='col-xs-12'>
                      <p className='ml-3 mb-2'>{this.props.checkinDate} - {this.props.checkoutDate}</p>
                    </div>
                    <div className='col-xs-9'>
                      <p className='ml-3 mb-2'>{adults} Adults, {children} Children</p>
                    </div>
                    <div className='col-xs-offset-3' />
                    <div className='col-xs-6'>
                      {this.props.roomDescriptions.map(roomDescription =>
                        <p className='ml-3 mb-2'>{roomDescription}</p>
                      )}
                    </div>
                    <div
                      className='col-xs-6 text-right'
                      onClick={() => this.props.trackValues('change', 'click')}
                      onKeyDown={(e) => e.key === 'Enter' && this.props.trackValues('change', 'keydown')}
                    >
                      <button
                        className='btn-link'
                        onClick={this.props.onChange}
                        onKeyDown={(e) => e.key === 'Enter' && this.props.onChange()}
                        role='presentation'
                        tabIndex='0'>
                        <FormattedMessage id='common.editSearch' /> &raquo;&raquo;
                      </button>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
          {hasTicketDescriptions &&
            <Collapse in={!collapsed}>
              <div className='fade summary-content bg-tertiary collapse-non-sm collapse-non-md collapse-non-lg'>
                <div className='block-xs container-fluid d-sm-flex small-xs'>
                  {Object.keys(this.props.ticketDescriptions).map(date => {
                    return (
                      <div className='pl-1 pr-4'>
                        <strong>{date}</strong>
                        {this.props.ticketDescriptions[date].map(details => {
                          return <p className='mb-0'>{details.name} - {details.time}: <span className='text-muted small'>{details.comp}</span></p>
                        })}
                      </div>
                    )
                  })}
                </div>
              </div>
            </Collapse>
          }
        </React.Fragment>
      )
    }

    if (_.get(config, 'brandConfig.secure.hasFeatures.hasFixedSummary', false)) {
      return (
        <React.Fragment>
          <div className='summary-panel container block-sm'>
            <div className='row'>
              <div className='col-lg-3 col-sm-2'>
                <h3 className={summaryTitleNonCollapsible}>
                  <FormattedMessage id='common.summary' />
                </h3>
                <a
                  className={summaryTitleCollapsible}
                  onClick={this.props.handleSummaryCollapseToggle}
                  onKeyDown={(e) => e.key === 'Enter' && this.props.handleSummaryCollapseToggle}>
                  <h3 className='h3 mt-0'>
                    <FormattedMessage id='common.summary' /> <span className='i-plus pull-right collapse-icon'>+</span>
                  </h3>
                </a>
              </div>

              <Collapse in={!collapsed}>
                <div className='summary-content collapse-non-sm collapse-non-md collapse-non-lg'>
                  <div className='col-sm-2 col-xs-6'>
                    <div
                      className='row'
                      onClick={() => this.props.trackValues('checkIn', 'click')}
                      onKeyDown={(e) => e.key === 'Enter' && this.props.trackValues('checkIn', 'keydown')}
                      role='presentation'
                      tabIndex='0'>
                      <div className='col-lg-12 col-md-12'>
                        <small className='text-muted'>
                          <FormattedMessage id='common.checkinDate' />
                        </small>
                      </div>
                      <div className='col-lg-12 col-md-12'>
                        <p className='larger m-0'>
                          {this.props.checkinDate}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className='col-sm-2 col-xs-6'>
                    <div
                      className='row'
                      onClick={() => this.props.trackValues('checkOut', 'click')}
                      onKeyDown={(e) => e.key === 'Enter' && this.props.trackValues('checkOut', 'keydown')}
                      role='presentation'
                      tabIndex='0'>
                      <div className='col-lg-12 col-md-12'>
                        <small className='text-muted'>
                          <FormattedMessage id='common.checkoutDate' />
                        </small>
                      </div>
                      <div className='col-lg-12 col-md-12'>
                        <p className='larger m-0'>
                          {this.props.checkoutDate}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className='col-md-3 col-sm-4 col-xs-8'
                    onClick={() => this.props.trackValues('roomDescriptions', 'click')}
                    onKeyDown={(e) => e.key === 'Enter' && this.props.trackValues('roomDescriptions', 'keydown')}
                    role='presentation'
                    tabIndex='0'>
                    <div className='row'>
                      <div className='col-lg-12 col-md-12'>
                        <small className='text-muted'>
                          {this.props.labelRooms}
                        </small>
                      </div>
                      <div className='col-lg-12 col-md-12'>
                        {this.props.roomDescriptions.map((roomDescription, roomDescriptionKey) =>
                          <p key={`roomDescription_${roomDescriptionKey}`} className='larger m-0'>{roomDescription}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className='col-lg-2'
                    onClick={() => this.props.trackValues('change', 'click')}
                    onKeyDown={(e) => e.key === 'Enter' && this.props.trackValues('change', 'keydown')}
                    role='presentation'
                    tabIndex='0'>
                    <div className='row'>
                      <div className='col-lg-12 text-right'>
                        <small className='d-block'>&nbsp;</small>
                        <button
                          className='btn-link'
                          onClick={this.props.onChange}
                          onKeyDown={(e) => e.key === 'Enter' && this.props.onChange()}
                          role='presentation'
                          tabIndex='0'>
                          <FormattedMessage id='common.change' /> &raquo;
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
          {hasTicketDescriptions &&
            <Collapse in={!collapsed}>
              <div className='fade summary-content bg-tertiary collapse-non-sm collapse-non-md collapse-non-lg'>
                <div className='block-xs container-fluid d-sm-flex small-xs text'>
                  {Object.keys(this.props.ticketDescriptions).map(date => {
                    return (
                      <div className='py-1 pr-4 flex-column'>
                        <strong>{date}</strong>
                        {this.props.ticketDescriptions[date].map(details => {
                          return <p className='mb-0'>{details.name} - {details.time}: <span className='text-muted small'>{details.comp}</span></p>
                        })}
                      </div>
                    )
                  })}
                </div>
              </div>
            </Collapse>
          }
        </React.Fragment>
      )
    }

    return (
      <div className='summary-panel'>
        <div className='row'>
          <div className='col-lg-2 col-md-2'>
            <div className='row'>
              <div
                className='col-lg-12 col-md-12 col-xs-5'
                onClick={() => this.props.trackValues('ticket', 'click')}
                onKeyDown={(e) => e.key === 'Enter' && this.props.trackValues('ticket', 'keydown')}
                role='presentation'
                tabIndex='0'>
                <small className='text-muted'>
                  {this.props.labelTickets}
                </small>
              </div>
              <div className='col-lg-12 col-md-12 col-xs-7' >
                <p className='larger m-0'>
                  {this.props.title}
                  {selectedItems &&
                    <span className='small d-block'>
                      {selectedItems.venueName}
                    </span>
                  }
                </p>
              </div>
              {selectedItems &&
                <React.Fragment>
                  <div className='col-lg-12 col-md-12 col-xs-5'>
                    <small className='text-muted'>
                      <FormattedMessage id='common.seats' />
                    </small>
                  </div>
                  <div className='col-lg-12 col-md-12 col-xs-7' >
                    {selectedItems.seats}
                  </div>
                </React.Fragment>
              }
            </div>
          </div>
          <div
            className='col-lg-2 col-md-2'
            onClick={() => this.props.trackValues('parkDate', 'click')}
            onKeyDown={(e) => e.key === 'Enter' && this.props.trackValues('parkDate', 'keydown')}
            role='presentation'
            tabIndex='0'>
            <div className='row'>
              <div className='col-lg-12 col-md-12 col-xs-5'>
                <small className='text-muted'>
                  {this.props.labelParkDate}
                </small>
              </div>
              <div className='col-lg-12 col-md-12 col-xs-7'>
                <p className='larger m-0'>
                  {this.props.parkDate}
                </p>
              </div>
              {selectedItems &&
                <React.Fragment>
                  <div className='col-lg-12 col-md-12 col-xs-5'>
                    <small className='text-muted'>
                      <FormattedMessage id='common.showTime' />
                    </small>
                  </div>
                  <div className='col-lg-12 col-md-12 col-xs-7'>
                    <p className='larger m-0'>
                      {selectedItems.timeslot}
                    </p>
                  </div>
                </React.Fragment>
              }
            </div>
          </div>
          <div className='col-lg-2 col-md-2'>
            <div
              className='row'
              onClick={() => this.props.trackValues('checkIn', 'click')}
              onKeyDown={(e) => e.key === 'Enter' && this.props.trackValues('checkIn', 'keydown')}
              role='presentation'
              tabIndex='0'>
              <div className='col-lg-12 col-md-12 col-xs-5'>
                <small className='text-muted'>
                  <FormattedMessage id='common.checkinDate' />
                </small>
              </div>
              <div className='col-lg-12 col-md-12 col-xs-7'>
                <p className='larger m-0'>
                  {this.props.checkinDate}
                </p>
              </div>
            </div>
            <div
              className='row'
              onClick={() => this.props.trackValues('checkOut', 'click')}
              onKeyDown={(e) => e.key === 'Enter' && this.props.trackValues('checkOut', 'click')}
              role='presentation'
              tabIndex='0'>
              <div className='col-lg-12 col-md-12 col-xs-5'>
                <small className='text-muted'>
                  <FormattedMessage id='common.checkoutDate' />
                </small>
              </div>
              <div className='col-lg-12 col-md-12 col-xs-7'>
                <p className='larger m-0'>
                  {this.props.checkoutDate}
                </p>
              </div>
            </div>
          </div>
          <div
            className='col-lg-2 col-md-2'
            onClick={() => this.props.trackValues('roomDescriptions', 'click')}
            onKeyDown={(e) => e.key === 'Enter' && this.props.trackValues('roomDescriptions', 'click')}
            role='presentation'
            tabIndex='0'>
            <div className='row'>
              <div className='col-lg-12 col-md-12 col-xs-5'>
                <small className='text-muted'>
                  {this.props.labelRooms}
                </small>
              </div>
              <div className='col-lg-12 col-md-12 col-xs-7'>
                {this.props.roomDescriptions.map((roomDescription, roomDescriptionKey) =>
                  <p key={`roomDescription_${roomDescriptionKey}`} className='larger m-0'>{roomDescription}</p>
                )}
              </div>
            </div>
          </div>
          <div
            className='col-lg-2 col-md-2'
            onClick={() => this.props.trackValues('party', 'click')}
            onKeyDown={(e) => e.key === 'Enter' && this.props.trackValues('party', 'keydown')}
            role='presentation'
            tabIndex='0'>
            <div className='row'>
              <div className='col-lg-12 col-md-12 col-xs-5'>
                <small className='text-muted'>
                  {this.props.labelPartyComp}
                </small>
              </div>
              <div className='col-lg-12 col-md-12 col-xs-7'>
                <p className='larger m-0'>
                  <PartyComposition
                    adults={this.props.adults}
                    children={this.props.children}
                    infants={this.props.infants}
                  />
                </p>
              </div>
            </div>
          </div>
          <div
            className='col-lg-2 col-md-2'
            onClick={() => this.props.trackValues('change', 'click')}
            onKeyDown={(e) => e.key === 'Enter' && this.props.trackValues('change', 'keydown')}
            role='presentation'
            tabIndex='0'>
            <div className='row'>
              <div className='col-lg-12 col-md-12 col-xs-7 col-xs-offset-5 col-sm-offset-0'>
                <button
                  className='btn btn-primary btn-sm btn-block'
                  onClick={this.props.onChange}
                  onKeyDown={(e) => e.key === 'Enter' && this.props.onChange()}>
                  <FormattedMessage id='common.change' />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Summary.defaultProps = {
  children: 0,
  handleSummaryCollapseToggle: () => {},
  infants: 0,
  isSummaryElementExpanded: true,
  isSummaryTitleClickable: false,
  trackValues: () => {}
}

Summary.propTypes = {
  adults: PropTypes.number.isRequired,
  checkinDate: PropTypes.string.isRequired,
  checkoutDate: PropTypes.string.isRequired,
  children: PropTypes.number,
  handleSummaryCollapseToggle: PropTypes.func.isRequired,
  infants: PropTypes.number,
  isSummaryElementExpanded: PropTypes.bool.isRequired,
  isSummaryTitleClickable: PropTypes.bool.isRequired,
  labelParkDate: PropTypes.string.isRequired,
  labelTickets: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  parkDate: PropTypes.string.isRequired,
  roomDescriptions: PropTypes.array,
  ticketDescriptions: PropTypes.object,
  title: PropTypes.string.isRequired,
  trackValues: PropTypes.func
}

export default Summary
